import { DefaultNotification } from "./DefaultNotification";
import { NotificationTypes } from "./NotificationTypes";

export class DefaultError extends DefaultNotification {
	constructor(notificationAdapter) {
		const message = "An error has occurred. If the problem persists, contact technical support.";
		super(notificationAdapter, NotificationTypes.ERROR, message);
	}
}
